import { runtimePublicConfig } from "@/runtime/config";

interface PublicPageLocation {
    origin: string;
    protocol: string;
}

/**
 * 生成旧 Vue `getConsoleAdminUrl` 对应的公众页地址。
 * 本地 HTTP 使用公众站开发端口，部署环境使用当前构建配置的站点域名。
 */
export function getPublicPageUrl(path: string, locationInfo: PublicPageLocation = window.location) {
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    if (locationInfo.protocol === "http:") return `http://localhost:5173${normalizedPath}`;
    return `${runtimePublicConfig.originUrl || locationInfo.origin}${normalizedPath}`;
}

/** 统一在新页签打开公众页，禁止业务页面自行拼接 `/console/public`。 */
export function openPublicPage(path: string) {
    window.open(getPublicPageUrl(path), "_blank");
}
